var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot101(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.86 36.43",
    style: {
      enableBackground: "new 0 0 69.86 36.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4C43D;}\r\n\t.st1{fill:#C16614;}\r\n\t.st2{fill:#518FDA;}\r\n\t.st3{fill:#FE9800;}\r\n\t.st4{fill:#2F2166;}\r\n\t.st5{fill:#E7EBF7;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#D4E6F4;}\r\n\t.st8{fill:#F5F9FC;}\r\n\t.st9{fill:#D89551;}\r\n\t.st10{fill:#C17E40;}\r\n\t.st11{fill:#A5622B;}\r\n\t.st12{fill:#965627;}\r\n\t.st13{fill:#EFA96A;}\r\n\t.st14{opacity:0.2;}\r\n\t.st15{fill:#FBC6B4;}\r\n\t.st16{fill:#F7422E;}\r\n\t.st17{fill:#F7B2A0;}\r\n\t.st18{fill:#1D1B3A;}\r\n\t.st19{fill:#F3B294;}\r\n\t.st20{fill:#A6BFED;}\r\n\t.st21{fill:#D2CDF9;}\r\n\t.st22{opacity:0.3;}\r\n\t.st23{fill:#EDA503;}\r\n\t.st24{fill:#FFB502;}\r\n\t.st25{fill:#738E11;}\r\n\t.st26{fill:#82A816;}\r\n\t.st27{fill:#663006;}\r\n\t.st28{fill:#C992D3;}\r\n\t.st29{fill:#728EE1;}\r\n\t.st30{fill:#F3F6FE;}\r\n\t.st31{fill:#515CB6;}\r\n\t.st32{fill:#FFAA3B;}\r\n\t.st33{fill:#6196EB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 13.36,
    transform: "matrix(0.7017 -0.7124 0.7124 0.7017 -8.5373 28.2045)",
    className: "st0",
    width: 1.84,
    height: 21.87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.08,
    y: 30.83,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -11.4307 34.5943)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.55,
    y: 30.41,
    transform: "matrix(0.702 -0.7122 0.7122 0.702 -11.3711 33.8917)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.85,
    y: 29.61,
    transform: "matrix(0.7019 -0.7122 0.7122 0.7019 -10.9329 33.3476)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.31,
    y: 29.19,
    transform: "matrix(0.7018 -0.7124 0.7124 0.7018 -10.8724 32.6597)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.62,
    y: 28.4,
    transform: "matrix(0.7018 -0.7124 0.7124 0.7018 -10.4341 32.1149)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.08,
    y: 27.98,
    transform: "matrix(0.7019 -0.7122 0.7122 0.7019 -10.3748 31.4095)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.38,
    y: 27.18,
    transform: "matrix(0.7017 -0.7124 0.7124 0.7017 -9.9355 30.8771)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.84,
    y: 26.76,
    transform: "matrix(0.7017 -0.7125 0.7125 0.7017 -9.8755 30.1834)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.15,
    y: 25.97,
    transform: "matrix(0.7018 -0.7123 0.7123 0.7018 -9.4378 29.6291)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.61,
    y: 25.55,
    transform: "matrix(0.7022 -0.712 0.712 0.7022 -9.3798 28.9112)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.91,
    y: 24.75,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -8.9401 28.3837)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.37,
    y: 24.33,
    transform: "matrix(0.7017 -0.7124 0.7124 0.7017 -8.8793 27.6962)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.68,
    y: 23.54,
    transform: "matrix(0.7018 -0.7123 0.7123 0.7018 -8.4416 27.1459)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.14,
    y: 23.11,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -8.3819 26.4466)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.44,
    y: 22.32,
    transform: "matrix(0.7018 -0.7124 0.7124 0.7018 -7.9433 25.9062)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.91,
    y: 21.9,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -7.8838 25.2058)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.21,
    y: 21.1,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -7.4457 24.6588)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 20.68,
    transform: "matrix(0.7021 -0.7121 0.7121 0.7021 -7.3866 23.9538)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.98,
    y: 19.89,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -6.9474 23.4193)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.44,
    y: 19.47,
    transform: "matrix(0.7019 -0.7123 0.7123 0.7019 -6.8873 22.7222)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.74,
    y: 18.67,
    transform: "matrix(0.7018 -0.7124 0.7124 0.7018 -6.4487 22.1817)",
    className: "st1",
    width: 1.06,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 18.25,
    transform: "matrix(0.7017 -0.7124 0.7124 0.7017 -6.3887 21.4856)",
    className: "st1",
    width: 0.53,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.51,
    y: 17.46,
    transform: "matrix(0.7018 -0.7123 0.7123 0.7018 -5.9509 20.9368)",
    className: "st1",
    width: 1.06,
    height: 0.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.62,21.45l-0.05,0.17c0,0,0.11,0.04,0.23,0.05c0.12,0.02,0.23,0.04,0.23,0.04l0.02-0.18 c0,0-0.11-0.02-0.22-0.04C27.73,21.48,27.62,21.45,27.62,21.45z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.01,21.19l-0.09,0.16c0,0,0.42,0.21,0.43,0.2l0.06-0.17C27.41,21.39,27.01,21.19,27.01,21.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.47,20.81l-0.12,0.14c0,0,0.09,0.08,0.18,0.15c0.1,0.07,0.2,0.13,0.2,0.13l0.1-0.15 c0,0-0.09-0.06-0.19-0.12C26.55,20.89,26.47,20.81,26.47,20.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.99,20.34l-0.14,0.12c0,0,0.08,0.08,0.16,0.17c0.08,0.09,0.16,0.17,0.16,0.17l0.12-0.13 c0,0-0.08-0.08-0.16-0.16C26.07,20.42,25.99,20.34,25.99,20.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.58,19.81l-0.15,0.1c0,0,0.06,0.1,0.13,0.19c0.07,0.09,0.14,0.18,0.14,0.18l0.14-0.11 c0,0-0.07-0.09-0.14-0.18C25.64,19.91,25.58,19.81,25.58,19.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.24,19.23l-0.16,0.08c0,0,0.22,0.41,0.23,0.41l0.15-0.09C25.45,19.63,25.24,19.23,25.24,19.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "24.96,18.62 24.79,18.68 24.98,19.11 25.14,19.03  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.74,17.98l-0.17,0.05c-0.01,0,0.14,0.44,0.14,0.44l0.17-0.06C24.88,18.41,24.73,17.98,24.74,17.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.59,17.32l-0.18,0.03c0,0,0.02,0.11,0.04,0.23c0.03,0.11,0.06,0.23,0.06,0.23l0.18-0.04 c0,0-0.03-0.11-0.06-0.22C24.61,17.43,24.59,17.32,24.59,17.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,16.65l-0.18,0.02c0,0,0.04,0.46,0.05,0.46l0.18-0.03C24.54,17.1,24.5,16.65,24.5,16.65z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "24.48,15.98 24.3,15.98 24.3,16.44 24.48,16.43  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "24.52,15.31 24.34,15.28 24.3,15.75 24.49,15.76  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.63,14.64l-0.18-0.04c-0.01,0-0.08,0.46-0.08,0.46l0.18,0.03C24.55,15.09,24.62,14.64,24.63,14.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.81,13.99l-0.17-0.06c-0.01,0-0.13,0.45-0.13,0.45l0.17,0.04C24.68,14.43,24.8,13.99,24.81,13.99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.05,13.36l-0.17-0.07c0,0-0.05,0.1-0.09,0.21c-0.04,0.11-0.08,0.22-0.08,0.22l0.17,0.06 c0,0,0.04-0.11,0.08-0.21C25,13.46,25.05,13.36,25.05,13.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.35,12.76l-0.16-0.09c0,0-0.06,0.1-0.12,0.2c-0.05,0.11-0.1,0.21-0.1,0.21l0.16,0.08 c0,0,0.05-0.1,0.1-0.21C25.3,12.86,25.35,12.76,25.35,12.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.72,12.19l-0.15-0.1c0,0-0.07,0.09-0.14,0.19c-0.06,0.1-0.12,0.2-0.12,0.2l0.15,0.09 c0,0,0.06-0.1,0.12-0.19C25.65,12.28,25.72,12.19,25.72,12.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.13,11.66l-0.14-0.12c0,0-0.08,0.09-0.15,0.17c-0.07,0.09-0.14,0.19-0.14,0.19l0.14,0.11 c0,0,0.07-0.09,0.13-0.18C26.06,11.75,26.13,11.66,26.13,11.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.59,11.17l-0.13-0.13c0,0-0.09,0.08-0.17,0.16c-0.08,0.09-0.15,0.17-0.15,0.17l0.13,0.12 c0,0,0.08-0.09,0.15-0.17C26.51,11.24,26.59,11.17,26.59,11.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.09,10.71l-0.12-0.14c-0.01-0.01-0.35,0.31-0.35,0.31l0.12,0.13C26.76,11.02,27.09,10.71,27.09,10.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "27.63,10.3 27.52,10.15 27.16,10.44 27.27,10.58  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.2,9.93 28.1,9.78 27.71,10.03 27.82,10.18  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.79,9.6 28.7,9.44 28.3,9.66 28.39,9.82  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.4,9.3l-0.08-0.16c0,0-0.1,0.05-0.21,0.09C29,9.28,28.9,9.33,28.9,9.34l0.08,0.16c0,0,0.1-0.06,0.2-0.1 C29.29,9.35,29.4,9.3,29.4,9.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.55,
    y: 8.95,
    transform: "matrix(0.9293 -0.3692 0.3692 0.9293 -1.2329 11.6324)",
    className: "st2",
    width: 0.46,
    height: 0.18
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "30.66,8.8 30.6,8.63 30.16,8.78 30.23,8.95  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.31,8.6l-0.05-0.17c0,0-0.11,0.03-0.22,0.06c-0.11,0.03-0.22,0.07-0.22,0.07l0.06,0.17 c0,0,0.11-0.04,0.22-0.07C31.2,8.63,31.31,8.6,31.31,8.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.49,
    y: 8.3,
    transform: "matrix(0.97 -0.2433 0.2433 0.97 -1.0874 7.9689)",
    className: "st2",
    width: 0.46,
    height: 0.18
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.62,8.26 32.59,8.09 32.14,8.18 32.18,8.36  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.29,8.12l-0.03-0.18c0,0-0.11,0.02-0.23,0.05c-0.11,0.02-0.23,0.05-0.23,0.05l0.04,0.18 c0,0,0.11-0.02,0.22-0.05C33.18,8.14,33.29,8.12,33.29,8.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.96,8.02 33.94,7.84 33.48,7.91 33.51,8.09  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.64,7.93l-0.02-0.18c0,0-0.12,0.01-0.23,0.03c-0.11,0.02-0.23,0.04-0.23,0.04l0.02,0.18 c0,0,0.11-0.02,0.23-0.04C34.52,7.93,34.64,7.93,34.64,7.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.31,7.9l0.01-0.18c0-0.01-0.47,0-0.47,0l0.01,0.18C34.86,7.9,35.31,7.89,35.31,7.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.97,7.98l0.03-0.18c0-0.01-0.46-0.06-0.46-0.06l-0.01,0.18C35.53,7.91,35.97,7.97,35.97,7.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.61,8.15l0.06-0.17c0,0-0.11-0.05-0.22-0.07c-0.11-0.03-0.23-0.06-0.23-0.06l-0.04,0.18 C36.19,8.02,36.62,8.14,36.61,8.15z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.22,8.43l0.09-0.16c0,0-0.1-0.06-0.21-0.11c-0.11-0.05-0.21-0.1-0.21-0.1l-0.07,0.17 c0,0,0.1,0.05,0.2,0.09C37.12,8.38,37.22,8.43,37.22,8.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.76,8.82l0.12-0.14c0,0-0.09-0.08-0.18-0.15C37.6,8.46,37.5,8.4,37.5,8.4l-0.1,0.15 c0,0,0.1,0.06,0.18,0.13C37.68,8.75,37.76,8.82,37.76,8.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.22,9.3l0.14-0.11c0,0-0.07-0.09-0.15-0.18c-0.08-0.08-0.16-0.17-0.16-0.17l-0.13,0.13 c0,0,0.08,0.08,0.15,0.16C38.15,9.21,38.22,9.3,38.22,9.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.58,9.85l0.16-0.08c0.01-0.01-0.24-0.41-0.25-0.4l-0.15,0.1C38.36,9.47,38.59,9.85,38.58,9.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.83,10.46l0.18-0.03c0,0-0.03-0.11-0.07-0.23c-0.04-0.11-0.09-0.22-0.09-0.22l-0.17,0.06 c0,0,0.05,0.1,0.08,0.2C38.79,10.36,38.83,10.46,38.83,10.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.93,11.11l0.19,0.02c0,0-0.01-0.12-0.02-0.24c-0.02-0.12-0.04-0.24-0.04-0.24l-0.18,0.01 c0,0,0.02,0.11,0.03,0.22C38.92,11,38.93,11.11,38.93,11.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.85,11.76l0.18,0.07c0,0,0.03-0.12,0.05-0.23c0.01-0.12,0.03-0.24,0.03-0.24l-0.19-0.04 c0,0-0.01,0.11-0.02,0.22C38.88,11.66,38.85,11.76,38.85,11.76z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.58,12.36l0.16,0.11c0.02,0.01,0.23-0.41,0.22-0.42l-0.17-0.08C38.8,11.97,38.6,12.37,38.58,12.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.12,12.82l0.12,0.15c0.01,0.02,0.36-0.31,0.35-0.31l-0.14-0.12C38.46,12.54,38.13,12.83,38.12,12.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.53,13.11l0.08,0.17c0,0,0.11-0.03,0.22-0.09c0.11-0.05,0.21-0.11,0.21-0.11l-0.11-0.16 c0,0-0.1,0.05-0.2,0.1C37.64,13.08,37.53,13.12,37.53,13.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.89,13.24l0.03,0.18c0,0,0.12-0.01,0.24-0.03c0.12,0,0.23-0.06,0.23-0.05l-0.06-0.18 c0,0-0.1,0.04-0.21,0.05C37,13.23,36.89,13.24,36.89,13.24z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.24,13.2l-0.02,0.18c0,0,0.03,0.01,0.07,0.02c0.04,0.01,0.1,0.02,0.16,0.02 c0.12,0.01,0.24,0.01,0.24,0.01l-0.01-0.18c0,0-0.11-0.01-0.22-0.01C36.35,13.23,36.24,13.19,36.24,13.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.61,13l-0.07,0.17c0,0,0.44,0.17,0.45,0.16l0.04-0.18C36.03,13.16,35.61,13,35.61,13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.04,12.67l-0.1,0.15c0,0,0.1,0.07,0.19,0.13c0.1,0.06,0.21,0.11,0.21,0.11l0.08-0.16 c0,0-0.1-0.05-0.2-0.1C35.13,12.73,35.04,12.67,35.04,12.67z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.51,12.25l-0.12,0.13c0,0,0.09,0.08,0.18,0.15c0.09,0.08,0.18,0.15,0.18,0.15l0.11-0.14 c0,0-0.09-0.07-0.17-0.14C34.6,12.33,34.51,12.25,34.51,12.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.05,11.77l-0.14,0.12c-0.01,0.01,0.32,0.34,0.32,0.34l0.13-0.13C34.35,12.1,34.04,11.78,34.05,11.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.63,11.24l-0.15,0.1c0,0,0.07,0.1,0.13,0.19c0.07,0.09,0.15,0.18,0.15,0.18l0.14-0.11 c0,0-0.07-0.09-0.14-0.18C33.7,11.33,33.63,11.24,33.63,11.24z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.27,10.67l-0.16,0.09c0,0,0.06,0.1,0.12,0.2c0.06,0.1,0.12,0.2,0.12,0.2l0.15-0.1 c0,0-0.06-0.09-0.12-0.19C33.33,10.77,33.27,10.67,33.27,10.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.96,10.07 32.8,10.14 33.01,10.56 33.16,10.47  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.71,9.44L32.54,9.5c-0.01,0,0.17,0.43,0.17,0.43l0.17-0.07C32.88,9.86,32.7,9.44,32.71,9.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.51,8.8l-0.17,0.05c0,0,0.02,0.11,0.06,0.22c0.04,0.11,0.07,0.22,0.07,0.22l0.17-0.06 c0,0-0.03-0.11-0.07-0.22C32.53,8.91,32.51,8.8,32.51,8.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.37,8.14l-0.18,0.03c0,0,0.02,0.11,0.04,0.23c0.02,0.11,0.05,0.23,0.05,0.23l0.18-0.04 c0,0-0.03-0.11-0.05-0.22C32.38,8.25,32.37,8.14,32.37,8.14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.28,7.47L32.1,7.48c0,0,0.04,0.46,0.05,0.46l0.18-0.03C32.32,7.92,32.28,7.47,32.28,7.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.25,6.79 32.07,6.79 32.08,7.25 32.26,7.25  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.29,6.12 32.11,6.1 32.08,6.56 32.26,6.57  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.4,5.45 32.22,5.42 32.14,5.87 32.32,5.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.58,4.81l-0.17-0.06C32.4,4.74,32.28,5.2,32.28,5.2l0.18,0.04C32.46,5.24,32.57,4.8,32.58,4.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.83,4.18l-0.16-0.08c0,0-0.06,0.1-0.1,0.21c-0.04,0.11-0.08,0.22-0.08,0.22l0.17,0.06 c0,0,0.04-0.11,0.08-0.21C32.77,4.28,32.83,4.18,32.83,4.18z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.15,3.59L33,3.5c0,0-0.06,0.1-0.12,0.2c-0.05,0.1-0.11,0.21-0.11,0.21l0.16,0.08c0,0,0.05-0.1,0.1-0.2 C33.09,3.69,33.15,3.59,33.15,3.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.54,3.04L33.4,2.93c0,0-0.07,0.09-0.15,0.18c-0.06,0.1-0.13,0.19-0.13,0.19l0.15,0.1 c0,0,0.06-0.1,0.12-0.19C33.47,3.13,33.54,3.04,33.54,3.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.99,2.54l-0.13-0.13c0,0-0.08,0.08-0.17,0.16c-0.08,0.08-0.15,0.18-0.15,0.18l0.14,0.12 c0,0,0.07-0.09,0.15-0.17C33.9,2.62,33.99,2.54,33.99,2.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.48,2.08l-0.12-0.14c0,0-0.09,0.07-0.18,0.15c-0.09,0.08-0.17,0.16-0.17,0.16l0.12,0.13 c0,0,0.08-0.08,0.16-0.16C34.39,2.15,34.48,2.08,34.48,2.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.02,1.68l-0.1-0.15c0,0-0.1,0.06-0.19,0.13c-0.09,0.07-0.18,0.14-0.18,0.14l0.11,0.14 c0,0,0.09-0.07,0.18-0.14C34.93,1.74,35.02,1.68,35.02,1.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.59,1.32l-0.09-0.16c-0.01-0.01-0.4,0.24-0.4,0.24l0.1,0.15C35.21,1.56,35.59,1.31,35.59,1.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "36.19,1.01 36.12,0.84 35.71,1.06 35.79,1.22  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "36.82,0.75 36.76,0.58 36.33,0.76 36.4,0.92  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "37.46,0.53 37.41,0.36 36.97,0.5 37.03,0.67  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.11,0.37 38.08,0.19 37.63,0.3 37.67,0.47  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.78,0.26 38.76,0.08 38.3,0.15 38.33,0.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39.46,0.19 39.45,0.01 38.99,0.06 39,0.24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.13,0.18 40.14,0 39.67,0.01 39.68,0.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.81,0.21 40.83,0.03 40.36,0.01 40.36,0.19  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "41.48,0.29 41.51,0.11 41.05,0.05 41.03,0.23  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.15,0.4 42.19,0.23 41.73,0.14 41.71,0.32  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.81,0.56 42.86,0.39 42.41,0.27 42.37,0.45  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.46,0.77l0.06-0.17c0,0-0.44-0.16-0.44-0.15l-0.05,0.17C43.03,0.61,43.46,0.77,43.46,0.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.09,1l0.07-0.17c0,0-0.11-0.05-0.21-0.09c-0.11-0.04-0.22-0.08-0.22-0.08l-0.06,0.17 c0,0,0.11,0.04,0.21,0.07C43.99,0.96,44.09,1,44.09,1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.71,1.28l0.08-0.16c0.01-0.01-0.42-0.19-0.42-0.19L44.3,1.09C44.3,1.09,44.71,1.27,44.71,1.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "45.31,1.6 45.4,1.44 44.99,1.23 44.91,1.39  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "45.88,1.96 45.98,1.81 45.59,1.56 45.5,1.71  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.44,2.35l0.11-0.14c0,0-0.37-0.28-0.37-0.27l-0.1,0.15C46.08,2.07,46.44,2.35,46.44,2.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.97,2.77l0.12-0.14c0,0-0.08-0.08-0.18-0.15c-0.09-0.07-0.18-0.14-0.18-0.14l-0.11,0.14 c0,0,0.09,0.07,0.18,0.14C46.89,2.69,46.97,2.77,46.97,2.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.47,3.22 47.6,3.09 47.25,2.78 47.14,2.92  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.95,3.71 48.08,3.58 47.76,3.25 47.64,3.38  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,4.21l0.14-0.11c0,0-0.07-0.09-0.15-0.18c-0.08-0.08-0.16-0.17-0.16-0.17L48.1,3.87 c0,0,0.08,0.08,0.15,0.17C48.33,4.12,48.4,4.21,48.4,4.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.8,4.75l0.15-0.1c0,0-0.26-0.39-0.27-0.38l-0.14,0.11C48.55,4.38,48.8,4.75,48.8,4.75z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.14,5.33 49.3,5.25 49.07,4.85 48.92,4.94  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.39,5.95l0.17-0.06c0,0-0.03-0.11-0.08-0.22c-0.05-0.11-0.09-0.21-0.09-0.21l-0.17,0.07 c0,0,0.05,0.1,0.09,0.21C49.37,5.84,49.39,5.95,49.39,5.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.58,6.6l0.18-0.04c0,0-0.11-0.45-0.12-0.45l-0.17,0.05C49.48,6.16,49.58,6.6,49.58,6.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.7,7.26l0.18-0.02c0.01,0-0.07-0.46-0.07-0.46l-0.18,0.03C49.63,6.82,49.71,7.26,49.7,7.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.75,7.94l0.18-0.01c0,0,0-0.12-0.01-0.23c0-0.12-0.02-0.23-0.02-0.23l-0.18,0.02 c0,0,0.02,0.11,0.02,0.23C49.74,7.82,49.75,7.94,49.75,7.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.75,8.61l0.18,0.01c0,0,0.01-0.12,0-0.23c0-0.12,0-0.23,0-0.23l-0.18,0c0,0,0,0.11,0,0.23 C49.75,8.5,49.75,8.61,49.75,8.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.71,9.29 49.89,9.31 49.92,8.85 49.74,8.84  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.64,9.97 49.82,9.99 49.87,9.53 49.69,9.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.57,10.65 49.75,10.67 49.8,10.21 49.62,10.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.51,11.33 49.69,11.35 49.73,10.89 49.55,10.88  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.47,12.02 49.65,12.03 49.67,11.57 49.49,11.56  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.49,12.71l0.18-0.01c0,0-0.01-0.11-0.01-0.23c0-0.11,0-0.23,0-0.23l-0.18,0c0,0,0,0.12,0,0.23 C49.48,12.6,49.49,12.71,49.49,12.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.57,13.4l0.18-0.03c-0.01,0-0.07-0.45-0.07-0.45l-0.18,0.02C49.51,12.94,49.56,13.4,49.57,13.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.76,14.08l0.17-0.06c0,0-0.14-0.43-0.13-0.43l-0.17,0.04C49.61,13.63,49.76,14.08,49.76,14.08z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.06,14.71l0.16-0.09c0,0-0.06-0.1-0.11-0.19c-0.05-0.1-0.09-0.21-0.09-0.21l-0.17,0.07 c0,0,0.05,0.11,0.09,0.22C50,14.61,50.06,14.71,50.06,14.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.46,15.28l0.14-0.12c0,0-0.07-0.09-0.14-0.18c-0.07-0.09-0.13-0.18-0.13-0.18l-0.15,0.1 c0,0,0.07,0.09,0.14,0.19C50.38,15.19,50.46,15.28,50.46,15.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.95,15.78l0.12-0.13c0,0-0.08-0.08-0.17-0.15c-0.08-0.08-0.15-0.17-0.15-0.17l-0.13,0.12 c0,0,0.08,0.09,0.16,0.17C50.86,15.7,50.95,15.78,50.95,15.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.49,16.21l0.1-0.15c0,0-0.09-0.07-0.18-0.13c-0.09-0.07-0.18-0.14-0.18-0.14l-0.12,0.14 c0,0,0.09,0.07,0.19,0.14C51.4,16.14,51.49,16.21,51.49,16.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "52.07,16.58 52.16,16.42 51.78,16.19 51.68,16.34  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "52.68,16.9 52.76,16.74 52.36,16.53 52.27,16.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "53.32,17.18 53.38,17.01 52.97,16.83 52.89,16.99  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,17.34l0.02-0.18c0,0-0.11-0.01-0.22-0.03c-0.05-0.01-0.11-0.02-0.15-0.03 c-0.04-0.01-0.07-0.02-0.07-0.02l-0.05,0.17c0,0,0.03,0.01,0.07,0.02c0.04,0.01,0.1,0.02,0.16,0.03 C53.88,17.33,54,17.34,54,17.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.7,17.37l0-0.18c0,0-0.11,0.01-0.23,0c-0.11,0-0.23-0.01-0.23-0.01l-0.01,0.18c0,0,0.12,0,0.23,0.01 C54.58,17.38,54.7,17.37,54.7,17.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.39,17.32l-0.03-0.18c0,0-0.11,0.02-0.22,0.03c-0.11,0.01-0.23,0.02-0.23,0.02l0.01,0.18 c0,0,0.12-0.01,0.23-0.02C55.27,17.34,55.39,17.32,55.39,17.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.07,17.17L56.02,17c0,0.01-0.44,0.11-0.44,0.11l0.03,0.18C55.61,17.28,56.07,17.18,56.07,17.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.72,16.91l-0.09-0.16c0,0-0.1,0.05-0.2,0.1c-0.1,0.05-0.21,0.08-0.21,0.08l0.06,0.17 c0,0,0.11-0.04,0.22-0.09C56.62,16.96,56.72,16.91,56.72,16.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.28,16.47l-0.14-0.12c0.02,0.01-0.31,0.3-0.32,0.29l0.1,0.15C56.93,16.8,57.3,16.48,57.28,16.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.58,15.81l-0.18-0.03c0.03,0.01-0.12,0.41-0.13,0.4l0.16,0.09c0.01,0,0.05-0.11,0.1-0.23 C57.58,15.94,57.57,15.81,57.58,15.81z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.53,15.09l-0.17,0.05c0,0,0.04,0.11,0.04,0.21c0.01,0.11,0.02,0.22,0.02,0.22l0.18,0 c0,0-0.01-0.12-0.03-0.24C57.57,15.21,57.53,15.09,57.53,15.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.3,14.44l-0.16,0.08c0,0,0.18,0.4,0.16,0.41l0.17-0.05C57.49,14.88,57.3,14.44,57.3,14.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.88,13.86l-0.13,0.13c0,0,0.07,0.08,0.15,0.16c0.07,0.08,0.12,0.18,0.12,0.18l0.15-0.1 c0,0-0.02-0.03-0.04-0.06c-0.03-0.04-0.05-0.09-0.1-0.13C56.96,13.95,56.88,13.86,56.88,13.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.28,13.47l-0.06,0.17c0,0,0.1,0.05,0.19,0.1c0.1,0.04,0.18,0.12,0.18,0.12l0.11-0.14 c0,0.01-0.09-0.09-0.2-0.13C56.39,13.52,56.28,13.47,56.28,13.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.58,13.34l0,0.18c0-0.01,0.44,0.04,0.43,0.06l0.04-0.18C56.06,13.38,55.58,13.33,55.58,13.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.88,13.42l0.04,0.18c0,0,0.03-0.01,0.07-0.02c0.04-0.01,0.1-0.02,0.15-0.02 c0.05-0.01,0.11-0.02,0.15-0.02c0.04,0,0.07,0,0.07,0l-0.01-0.18c0,0-0.03,0-0.07,0c-0.04,0.01-0.1,0.02-0.16,0.03 c-0.06,0.01-0.12,0.02-0.16,0.03C54.91,13.41,54.88,13.42,54.88,13.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.22,13.64l0.07,0.17c0,0,0.42-0.17,0.42-0.15l-0.05-0.17C54.65,13.47,54.22,13.64,54.22,13.64z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.6,13.97l0.09,0.15c0,0,0.1-0.06,0.19-0.12c0.1-0.05,0.2-0.1,0.2-0.1l-0.08-0.16 c0,0-0.11,0.05-0.21,0.11C53.7,13.91,53.6,13.97,53.6,13.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.03,14.37l0.11,0.14c-0.01-0.01,0.36-0.27,0.36-0.27l-0.1-0.15C53.41,14.09,53.03,14.36,53.03,14.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.51,14.82l0.13,0.13c0,0,0.08-0.08,0.16-0.16c0.08-0.08,0.17-0.15,0.17-0.15l-0.12-0.14 c0,0-0.09,0.07-0.17,0.15C52.6,14.75,52.51,14.82,52.51,14.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.04,15.33l0.14,0.12c-0.01-0.01,0.3-0.34,0.3-0.34l-0.13-0.13c0,0-0.08,0.09-0.16,0.17 C52.11,15.24,52.04,15.33,52.04,15.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.62,15.88l0.15,0.1c0,0,0.07-0.09,0.13-0.19c0.06-0.09,0.14-0.18,0.14-0.18l-0.14-0.11 c0,0-0.08,0.09-0.14,0.18C51.69,15.79,51.62,15.88,51.62,15.88z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "51.25,16.47 51.41,16.56 51.64,16.17 51.49,16.07  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.95,17.09l0.17,0.07c0,0,0.04-0.1,0.09-0.21c0.05-0.1,0.1-0.2,0.1-0.2l-0.16-0.08 c0,0-0.05,0.1-0.11,0.21C51,16.98,50.95,17.09,50.95,17.09z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.71,17.74l0.17,0.05c0,0,0.14-0.43,0.15-0.43l-0.17-0.07C50.85,17.3,50.71,17.74,50.71,17.74z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.54,18.42l0.18,0.03c-0.01,0,0.1-0.44,0.1-0.44l-0.17-0.05C50.65,17.96,50.53,18.41,50.54,18.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.46,19.1l0.18,0.01c0,0,0.01-0.11,0.01-0.23c0.01-0.11,0.03-0.22,0.03-0.22l-0.18-0.03 c0,0-0.02,0.12-0.03,0.23C50.47,18.99,50.46,19.1,50.46,19.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.46,19.8 50.64,19.79 50.63,19.34 50.45,19.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.55,20.49l0.18-0.04c-0.01,0-0.07-0.45-0.07-0.45l-0.18,0.02C50.48,20.03,50.54,20.49,50.55,20.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.74,21.16l0.17-0.06c0,0-0.04-0.11-0.07-0.21c-0.03-0.11-0.05-0.22-0.05-0.22l-0.18,0.04 c0,0,0.03,0.11,0.05,0.23C50.7,21.05,50.74,21.16,50.74,21.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51,21.8l0.16-0.08c0,0-0.19-0.41-0.18-0.41l-0.17,0.07C50.8,21.38,51,21.8,51,21.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.98,11.79c0-0.2,0.17-0.37,0.37-0.36c0.2,0,0.37,0.17,0.36,0.37c0,0.2-0.17,0.37-0.37,0.36 C45.14,12.16,44.97,11.99,44.98,11.79z M45.61,11.8c0-0.15-0.12-0.27-0.26-0.27c-0.15,0-0.27,0.12-0.27,0.26 c0,0.15,0.12,0.27,0.26,0.27C45.49,12.07,45.61,11.95,45.61,11.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.04,11.54l0.08-0.07l0.29,0.32c0.08,0.1,0.23,0.1,0.33,0.02l0.26-0.23c0.07-0.06,0.15-0.09,0.24-0.08 c0.09,0.01,0.17,0.05,0.23,0.11l0.19,0.21c0.04,0.05,0.1,0.08,0.16,0.08c0.06,0,0.12-0.02,0.17-0.06l0.23-0.21 c0.07-0.06,0.16-0.09,0.25-0.09c0.09,0.01,0.18,0.05,0.23,0.13l0.12,0.15c0.04,0.05,0.11,0.09,0.17,0.09 c0.07,0,0.13-0.02,0.18-0.07l0.28-0.3l0.07,0.07l-0.27,0.3c-0.07,0.07-0.16,0.11-0.26,0.11c-0.1,0-0.19-0.05-0.25-0.13 l-0.12-0.15c-0.04-0.05-0.1-0.08-0.16-0.09c-0.06-0.01-0.13,0.02-0.18,0.06l-0.23,0.21c-0.07,0.06-0.15,0.09-0.24,0.09 c-0.09-0.01-0.17-0.05-0.23-0.11l-0.19-0.21c-0.04-0.05-0.1-0.07-0.16-0.08c-0.06,0-0.12,0.02-0.17,0.06l-0.26,0.23 c-0.14,0.12-0.35,0.11-0.47-0.03L41.04,11.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "28.05,35.19 53.61,35.19 57.78,16.62 33.09,16.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "29.94,33.89 51.94,33.89 55.99,17.91 34.28,17.91  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.82,31.5c-0.12,0.46-0.6,0.83-1.06,0.83H31.48c-0.46,0-0.73-0.37-0.61-0.83l3.07-11.46 c0.12-0.46,0.6-0.83,1.06-0.83h18.28c0.46,0,0.73,0.37,0.61,0.83L50.82,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.28,19.2H35c-0.46,0-0.93,0.37-1.06,0.83l-0.41,1.55h19.94l0.41-1.55C54.01,19.57,53.74,19.2,53.28,19.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.86,20.4c-0.06,0.23-0.3,0.41-0.52,0.41c-0.23,0-0.36-0.19-0.3-0.41c0.06-0.23,0.3-0.41,0.53-0.41 C35.79,19.98,35.93,20.17,35.86,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.91,20.4c-0.06,0.23-0.3,0.41-0.53,0.41c-0.23,0-0.36-0.19-0.3-0.41c0.06-0.23,0.3-0.41,0.52-0.41 C36.83,19.98,36.97,20.17,36.91,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.92,20.4c-0.06,0.23-0.3,0.41-0.52,0.41c-0.23,0-0.36-0.19-0.3-0.41c0.06-0.23,0.3-0.41,0.52-0.41 C37.84,19.98,37.98,20.17,37.92,20.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "40.77,31.15 34.09,31.15 34.54,29.46 41.22,29.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "48.33,31.15 41.65,31.15 42.1,29.46 48.78,29.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "50.75,28.59 33.14,28.59 34.78,22.48 52.38,22.48  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 14.12,
    className: "st9",
    width: 5.42,
    height: 18.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 14.12,
    className: "st10",
    width: 2.55,
    height: 18.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.91,
    y: 14.12,
    className: "st9",
    width: 3.28,
    height: 18.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.36,
    y: 14.12,
    className: "st11",
    width: 1.55,
    height: 18.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.73,
    y: 18.27,
    className: "st9",
    width: 5.42,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.17,
    y: 18.27,
    className: "st10",
    width: 2.56,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.74,
    y: 24.88,
    className: "st9",
    width: 2.71,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.48,
    y: 24.88,
    className: "st10",
    width: 5.26,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.54,
    y: 32.68,
    className: "st11",
    width: 24.19,
    height: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 14.73,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 15.78,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 17.18,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 18.24,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 19.63,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 20.69,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 22.09,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 23.14,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 24.54,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 25.6,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 26.99,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 28.05,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 29.45,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 30.5,
    className: "st12",
    width: 4.02,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 14.73,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 15.78,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 17.18,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 18.24,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 19.63,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 20.69,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 22.09,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 23.14,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 24.54,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 25.6,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 26.99,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 28.05,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 29.45,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 30.5,
    className: "st11",
    width: 3.7,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 18.99,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.78,
    y: 18.99,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.15,
    y: 18.99,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.27,
    y: 18.99,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.57,
    y: 14.44,
    className: "st11",
    width: 0.48,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.42,
    y: 14.44,
    className: "st10",
    width: 0.48,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.21,
    y: 14.44,
    className: "st11",
    width: 0.47,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.06,
    y: 14.44,
    className: "st10",
    width: 0.47,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.57,
    y: 16.07,
    className: "st11",
    width: 0.48,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.42,
    y: 16.07,
    className: "st10",
    width: 0.48,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.21,
    y: 16.07,
    className: "st11",
    width: 0.47,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.06,
    y: 16.07,
    className: "st10",
    width: 0.47,
    height: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.54,
    y: 18.99,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.91,
    y: 18.99,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 21.44,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.78,
    y: 21.44,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.15,
    y: 21.44,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.15,
    y: 23.89,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.15,
    y: 28.8,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.27,
    y: 21.44,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.54,
    y: 21.44,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.91,
    y: 21.44,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 23.89,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.78,
    y: 23.89,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.27,
    y: 23.89,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.54,
    y: 23.89,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.91,
    y: 23.89,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 26.35,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.78,
    y: 26.35,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.15,
    y: 26.35,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.27,
    y: 26.35,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.54,
    y: 26.35,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.91,
    y: 26.35,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 28.8,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.78,
    y: 28.8,
    className: "st11",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.27,
    y: 28.8,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.54,
    y: 28.8,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.91,
    y: 28.8,
    className: "st10",
    width: 0.77,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.26,
    y: 23.4,
    className: "st13",
    width: 4.58,
    height: 9.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 23.4,
    className: "st11",
    width: 2.16,
    height: 9.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.1,23.4 35.73,32.68 39.1,32.68  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.17,18.27 32.12,24.88 33.17,24.88  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 25.48,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 25.48,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 26.29,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 26.29,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 27.11,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 27.11,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 27.93,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 27.93,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 28.75,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 28.75,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 29.56,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 29.56,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 30.38,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 30.38,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 31.2,
    className: "st12",
    width: 1.57,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 31.2,
    className: "st11",
    width: 1.26,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 23.89,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 23.89,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 24.71,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 24.71,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 25.53,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 25.53,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 26.35,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 26.35,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 27.16,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 27.16,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 27.98,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 27.98,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 28.8,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 28.8,
    className: "st11",
    width: 3.44,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 29.62,
    className: "st12",
    width: 3.85,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.66,
    y: 29.62,
    className: "st11",
    width: 3.44,
    height: 0.17
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 33.07,
    className: "st4",
    width: 35.9,
    height: 2.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.3,23.29c0,0,0.8-1.16,0.96-1.6c0.23-0.62,0.45-2.61,0.45-2.61s0.21-1.51,0.51-1.15 c0.1,0.12-0.05,0.96-0.11,1.27c-0.16,0.78,0.3,1.87-0.07,3.17c-0.15,0.53-0.92,2.32-0.92,2.32L64.3,23.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.96,26.43c-0.46-1.24,0.26-2.43,0.11-3.23c-0.18-0.95-1.83-0.73-2.42-0.48 c-0.59,0.24-1.57,0.62-0.88,1.85c0.49,0.86,0.41,1.48,0.36,2.46l0,0c0,0.03-0.01,0.05-0.01,0.07c0,0,0,0,0,0c0,0,0,0,0,0 c-0.31,2.77-0.45,3.76-0.7,4.8c-0.28,1.2-0.6,3.75-0.07,3.77c0.53,0.01,0.83-0.16,0.52-0.26c-0.31-0.1-0.32-0.13-0.31-0.23 c0.13-1.24,1.88-3.16,2.03-4.63c0.05-0.5,0.08-0.96,0.11-1.36c0.2,1.08,0.05,2.22,0.07,2.59c0.06,1.34,0.32,3.88,0.9,3.88 c0.62,0.01,0.93-0.18,0.53-0.27c-0.34-0.08-0.33-0.1-0.32-0.19c0.08-1.36,0.68-3.86,0.8-5.47 C65.82,27.88,64.98,26.5,64.96,26.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.12,26.75c-1.06,0.78-2.43,0.54-3.01,0.41c-0.16,1.39-1.07,6.61-1.18,7.33c0.47,0.17,0.62,0.21,0.76,0.21 c2.49-3.66,2-5.1,2.03-5.51c0.09,0.46,0.1,3.18,0.28,5.51c0.16,0.12,0.66,0.27,1.01,0c0.02-0.14,0.67-4.83,0.68-4.97 C65.78,28.37,65.36,27.27,65.12,26.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.52,22.76c0,0,0.72,1.53,1.78,1.3c0.32-0.07,0.57-0.52-0.41-1.61l0.35,0.08c0,0,0.94,1.17,1.25,2.77 c0.3,1.6,0,2.33,0,2.33s-0.32,0.28-1.79,0.41c-0.65,0.06-1.21,0.01-1.69-0.14c0,0,0.2-1.84,0.09-2.46c0,0,0.87,0,0.78-1.16 c-0.08-0.96-0.65-1.41-0.65-1.41L62.52,22.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M62.79,21.87c0,0,0.34,0.44,0.05,0.78c-0.29,0.35,1.25,0.77,1.15,0.49c-0.13-0.36-0.36-0.54-0.28-1 L62.79,21.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M63.37,20.76c0.38,0.23,1.01,1.46,0.75,1.82c-0.12,0.16-0.74,0.15-1.25-0.34c-0.21-0.2-0.5-0.6-0.36-1.1 C62.57,20.91,62.92,20.5,63.37,20.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M63.72,20.85c0.11,0.15,0.09,0.19-0.38,0.38c-0.47,0.19-0.57,0.17-0.49,0.28c0.22,0.31-0.14,0.32,0.13,0.7 c0.27,0.37-0.2,0.21-0.46-0.08c-0.05-0.06-0.33-0.34-0.21-0.91C62.46,20.54,63.33,20.3,63.72,20.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M62.98,22.2c0,0,0.1,0.1,0.34,0c0.25-0.1,0.58-0.44,0.72-0.43c0.14,0.01,0.31,0.73,0.06,0.9 c-0.25,0.17-1,0-1.25-0.3C62.8,22.3,62.98,22.2,62.98,22.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M63.69,22.3c0,0,0.06-0.23,0.23-0.28c0.16-0.05,0.18,0.16,0.16,0.23c-0.02,0.07-0.25,0.26-0.39,0.22 C63.56,22.43,63.66,22.38,63.69,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.36,35.36c0,0,0.47,0.2,0.75,0c0,0,0.52,0.08,0.19,0.22C64.97,35.72,64.34,35.84,64.36,35.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.13,35.41c0,0,0.46,0.2,0.75,0c0,0,0.52,0.08,0.19,0.22C61.75,35.77,61.11,35.88,61.13,35.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M62.47,23.39c0,0-1.17-0.79-1.48-1.13C60.55,21.77,59.62,20,59.62,20s-0.75-1.33-0.9-0.88 c-0.05,0.14,0.4,0.87,0.57,1.14c0.44,0.66,0.47,2.07,1.23,2.92C60.89,23.6,62.23,25,62.23,25L62.47,23.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M66.78,20.26c0,0,0.69,0.11,1.76-0.22c0,0-0.28,0.96,0.09,1.55c0,0-2.11,0.26-2.38,0.69 C66.25,22.27,66.92,21.16,66.78,20.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M58.74,24.55c0,0,0.69,0.11,1.76-0.22c0,0-0.28,0.96,0.09,1.55c0,0-2.1,0.26-2.38,0.69 C58.21,26.56,58.88,25.45,58.74,24.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M67.36,17.64c0,0,0.47,0.08,1.21-0.15c0,0-0.19,0.66,0.06,1.06c0,0-1.44,0.18-1.63,0.47 C67,19.02,67.46,18.26,67.36,17.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M56.85,22.54c0,0-0.12-0.67-0.75-1.54c0,0,0.97-0.04,1.38-0.57c0,0,0.9,1.84,1.37,1.96 C58.85,22.4,57.63,22.13,56.85,22.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "62.47,16.32 61.33,16.26 61.31,17.46 62.45,17.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "64.58,18.83 63.44,18.77 63.42,19.98 64.56,20.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "63.71,29.19 64.02,28.76 63.81,31.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.08,29.14l-0.01-0.06c0.19-0.02,0.33-0.1,0.4-0.21c0.13-0.2,0.06-0.46,0.06-0.47l0.06-0.02 c0,0.01,0.08,0.29-0.06,0.52C62.44,29.03,62.29,29.12,62.08,29.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.39,28.88c-0.21-0.03-0.36-0.11-0.45-0.24c-0.15-0.22-0.07-0.5-0.06-0.52l0.06,0.02 c0,0-0.07,0.27,0.06,0.47c0.08,0.12,0.22,0.19,0.4,0.22L65.39,28.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.05,16.83l0.45,2.75l13.04-2.14c0.03,0.01,0.05,0.02,0.08,0.01c0.23-0.04,0.31-0.68,0.19-1.44 c-0.12-0.76-0.41-1.35-0.64-1.31c-0.01,0-0.02,0.01-0.03,0.01l0-0.03L56.05,16.83z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.54,17.45c0.03,0.01,0.05,0.02,0.08,0.01c0.23-0.04,0.31-0.68,0.19-1.44c-0.02-0.1-0.04-0.2-0.06-0.29l-13.46,2.6 l0.21,1.26L69.54,17.45z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M56.07,16.83c0.23-0.04,0.51,0.55,0.64,1.31c0.12,0.76,0.04,1.41-0.19,1.44c-0.23,0.04-0.51-0.55-0.64-1.31 C55.76,17.51,55.84,16.87,56.07,16.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M62.64,21.62c0,0,1.41-0.4,1.34-0.84c-0.04-0.27-0.86-0.16-0.86-0.16L62.64,21.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M63.56,20.82c-0.11,0.42-0.44,0.66-1.31,0.93c0,0-0.47-0.84,0.14-1.28 C62.92,20.08,63.63,20.55,63.56,20.82z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M54.57,24.4c0,0,0.59,4.58-0.15,7.31h0.3C54.73,31.71,55.39,27.77,54.57,24.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M56.89,26.67c0,0-1.91,2.81-2.06,4.92l-0.28-0.13C54.55,31.46,55.12,28.57,56.89,26.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.08,26.19c0,0-2.23,0.94-2.36,4.31l-0.15,0.22C54.57,30.72,54.17,27.36,57.08,26.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M52.84,26.04c0,0,1.97,1.4,1.36,4.73l0.1,0.25C54.29,31.01,55.43,27.82,52.84,26.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.46,27.3c0,0,1.91,2.81,2.06,4.92l0.28-0.12C54.79,32.1,54.22,29.2,52.46,27.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M54.72,21.28c-3.72,2.79-2.25,4.95-1.79,5.13c1.09,0.42,1.42-0.72,1.74-0.72c0.33,0,0.65,1.14,1.74,0.72 C56.89,26.23,58.44,24.07,54.72,21.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.63,22.41c0,0,0.31,1.26,0.11,3.04C54.74,25.45,55.34,24.36,54.63,22.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M55.37,23.18c0,0-0.09,0.67-0.45,0.99l0.01,0.15C54.92,24.31,55.4,23.85,55.37,23.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.31,22.79c0,0,0.18,0.65,0.57,0.92l0.01,0.15C54.9,23.86,54.37,23.47,54.31,22.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M56.23,23.91c0,0-0.61,0.83-1.33,1l-0.09,0.2C54.8,25.11,55.77,24.84,56.23,23.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M53.35,23.86c0,0,0.73,1.25,1.46,1.33l-0.01,0.12C54.8,25.31,53.73,25.05,53.35,23.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.03,23.64c0,0,0.12,0.77,0.83,1.07l0.02,0.1C54.88,24.82,54.09,24.67,54.03,23.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M55.07,22.63c0,0-0.04,0.45-0.22,0.66l0.01,0.1C54.86,23.39,55.1,23.09,55.07,22.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M58.06,29.49c0.62-2.77-0.91-3.2-1.2-3.09c-0.68,0.24-0.38,0.9-0.53,1.02c-0.15,0.13-0.75-0.27-1.1,0.36 C55.09,28.05,55.22,29.66,58.06,29.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.93,29.21c0,0-0.78-0.56-1.52-1.66C56.41,27.55,56.59,28.46,57.93,29.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.14,29.14c0,0-0.27-0.42-0.22-0.78l-0.08-0.08C56.85,28.28,56.8,28.77,57.14,29.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.92,28.85c0,0-0.41-0.28-0.77-0.24l-0.08-0.08C57.08,28.53,57.57,28.49,57.92,28.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M56.31,29.14c0,0-0.05-0.76,0.27-1.2l-0.05-0.16C56.53,27.77,56.11,28.39,56.31,29.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.96,27.78c0,0-1.01-0.36-1.46-0.05l-0.05-0.07C56.44,27.66,57.17,27.29,57.96,27.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.67,28.23c0,0-0.44-0.37-0.98-0.21l-0.06-0.05C56.63,27.97,57.15,27.68,57.67,28.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.57,29.3c0,0-0.2-0.27-0.2-0.48l-0.05-0.05C57.32,28.77,57.34,29.06,57.57,29.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M52.58,28.55c2.71,0.4,3.01-1.11,2.89-1.38c-0.28-0.63-0.89-0.3-1.02-0.43c-0.14-0.14,0.21-0.75-0.42-1.03 C53.75,25.59,52.2,25.84,52.58,28.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.83,28.41c0,0,0.48-0.79,1.49-1.59C54.32,26.82,53.46,27.06,52.83,28.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.85,27.65c0,0,0.39-0.29,0.73-0.27l0.07-0.08C53.65,27.3,53.18,27.29,52.85,27.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M53.18,28.37c0,0,0.24-0.42,0.18-0.76l0.07-0.08C53.43,27.54,53.5,28.01,53.18,28.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.79,26.84c0,0,0.73-0.11,1.18,0.17l0.15-0.06C54.12,26.96,53.49,26.6,52.79,26.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M54.21,28.33c0,0,0.27-1-0.06-1.41l0.07-0.06C54.22,26.86,54.63,27.54,54.21,28.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M53.76,28.09c0,0,0.33-0.45,0.13-0.96l0.04-0.06C53.93,27.07,54.25,27.54,53.76,28.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.72,28.07c0,0,0.25-0.21,0.44-0.22l0.05-0.05C53.21,27.79,52.94,27.83,52.72,28.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M50.34,26.63c0.64,2.77,2.21,2.49,2.42,2.27c0.51-0.51-0.05-0.97,0.03-1.15c0.08-0.18,0.8-0.08,0.83-0.8 C53.64,26.64,52.82,25.24,50.34,26.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M50.57,26.82c0,0,0.95,0.17,2.09,0.84C52.67,27.66,52.11,26.92,50.57,26.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.31,26.55c0,0,0.43,0.26,0.53,0.6l0.1,0.04C51.95,27.19,51.78,26.73,51.31,26.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M50.74,27.15c0,0,0.5,0.08,0.8-0.11l0.1,0.04C51.64,27.07,51.21,27.31,50.74,27.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M52.07,26.19c0,0,0.38,0.67,0.28,1.2l0.11,0.13C52.46,27.51,52.56,26.77,52.07,26.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.17,28.12c0,0,1.07-0.12,1.34-0.59l0.08,0.04C52.59,27.58,52.09,28.22,51.17,28.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.23,27.59c0,0,0.56,0.15,0.98-0.24l0.08,0.02C52.28,27.37,51.94,27.87,51.23,27.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M50.86,26.58c0,0,0.29,0.16,0.38,0.35l0.07,0.03C51.31,26.95,51.17,26.7,50.86,26.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M58.2,25.92c-1.62-1.1-2.28-0.23-2.29-0.02c-0.02,0.49,0.48,0.47,0.52,0.6c0.04,0.13-0.37,0.41-0.05,0.79 C56.52,27.45,57.59,27.78,58.2,25.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.99,25.93c0,0-0.56,0.36-1.45,0.55C56.54,26.48,57.17,26.6,57.99,25.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.74,26.41c0,0-0.34,0.07-0.55-0.06l-0.07,0.03C57.12,26.38,57.42,26.54,57.74,26.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.76,25.84c0,0-0.29,0.19-0.35,0.43l-0.07,0.03C57.34,26.3,57.44,25.98,57.76,25.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.53,26.95c0,0-0.5-0.16-0.7-0.48l-0.11-0.01C56.72,26.46,57.01,26.88,57.53,26.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.08,25.55c0,0-0.49,0.56-0.4,0.92l-0.06,0.02C56.62,26.49,56.57,25.93,57.08,25.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.3,25.84c0,0-0.35,0.18-0.38,0.58l-0.05,0.03C56.87,26.45,56.81,26.04,57.3,25.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M57.96,26.18c0,0-0.22,0.06-0.36,0l-0.05,0.02C57.56,26.21,57.74,26.27,57.96,26.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M55.15,30.39c0,0.16,0.14,0.29,0.32,0.29c0.18,0,0.32-0.13,0.32-0.29c0-0.16-0.14-0.29-0.32-0.29 C55.3,30.1,55.15,30.23,55.15,30.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M54.21,30.1c0,0.32,0.28,0.58,0.63,0.58c0.35,0,0.63-0.26,0.63-0.58c0-0.32-0.28-0.58-0.63-0.58 C54.49,29.53,54.21,29.78,54.21,30.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M53.89,30.24c0,0.16,0.14,0.28,0.31,0.28c0.17,0,0.31-0.13,0.31-0.28c0-0.16-0.14-0.28-0.31-0.28 C54.03,29.95,53.89,30.08,53.89,30.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M53.65,30.18c0,0.12,0.11,0.22,0.24,0.22c0.13,0,0.24-0.1,0.24-0.22c0-0.12-0.11-0.22-0.24-0.22 C53.76,29.97,53.65,30.06,53.65,30.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M53.31,30.25c0,0.14,0.12,0.25,0.27,0.25c0.15,0,0.27-0.11,0.27-0.25c0-0.14-0.12-0.25-0.27-0.25 C53.44,30,53.31,30.11,53.31,30.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M56.14,30.27H54.9h-0.4h-1.24c0,0-0.09,3.25,0.89,4.87h0.35h0.4h0.35C56.23,33.52,56.14,30.27,56.14,30.27z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "8.9,35.18 9.53,35.18 10.26,30.99 9.64,30.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "18.88,35.21 18.25,35.21 17.51,31.02 18.14,31.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "18.83,32.24 8.52,32.24 8.55,17.05 18.83,19.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "15.73,35.21 15.11,35.21 14.37,31.02 14.99,31.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "23.44,35.21 22.82,35.21 22.08,31.02 22.71,31.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "24.04,32.28 13.48,32.23 8.55,17.05 18.44,17.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "23.49,31.73 13.68,31.69 9.11,17.6 18.28,17.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "18.28,19.74 10.85,19.73 10.65,19.1 18.02,19.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M19.77,27.56l1,2.83l-4.62-0.05l-1-2.83L19.77,27.56z M20.51,30.2l-0.86-2.43l-4.22-0.04l0.86,2.43 L20.51,30.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M19.68,24.94l1,2.83l-6.86-0.07l-1-2.83L19.68,24.94z M20.41,27.57l-0.86-2.43l-6.46-0.06l0.86,2.43 L20.41,27.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M15.72,20.45l1.65,4.66l-2.73-0.03l-1.65-4.66L15.72,20.45z M17.1,24.91l-1.51-4.26l-2.33-0.02l1.51,4.26 L17.1,24.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "13.69,25.63 14.15,26.94 13.2,26.93 12.74,25.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "16.22,24.36 16.68,25.66 15.72,25.65 15.26,24.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "18.37,26.88 18.83,28.18 17.88,28.17 17.42,26.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "17.64,29.25 18.1,30.55 17.14,30.54 16.68,29.24  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "14.06,21.83 14.52,23.13 13.57,23.12 13.11,21.82  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M19.05,29.05l0.45,1.28l-1-0.01l-0.45-1.28L19.05,29.05z M19.37,30.23l-0.38-1.08l-0.8-0.01l0.38,1.08 L19.37,30.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M16.25,22.18l0.78,2.2l-1.49-0.01l-0.78-2.2L16.25,22.18z M16.89,24.27l-0.71-2l-1.29-0.01l0.71,2 L16.89,24.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "15.07,22.58 15.45,23.65 15.21,23.64 14.83,22.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.89,27.25 16.02,27.63 15.92,27.63 15.79,27.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.68,26.65 15.81,27.03 15.71,27.02 15.57,26.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.46,26.05 15.6,26.43 15.49,26.42 15.36,26.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "18.34,25.69 18.75,26.87 18.65,26.87 18.24,25.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.25,25.45 15.38,25.83 15.28,25.82 15.15,25.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.06,24.93 15.17,25.23 15.07,25.22 14.96,24.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "15.5,22.17 15.54,22.27 14.21,22.26 14.18,22.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "18.53,28.75 18.71,29.26 18.42,29.26 18.24,28.74  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M18.76,24.69c0,0,0.34-0.23,0.64-0.18c0.35,0.05,0.28,0.08,0.57,0.14l-0.04,0.31c0,0-0.21,0-0.27-0.04 c-0.1-0.05-0.16-0.06-0.36-0.13c-0.19-0.07-0.19-0.12-0.35-0.07C18.71,24.79,18.76,24.69,18.76,24.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M19.58,24.76c0,0-0.54,0.17-0.42,0.25c0.12,0.08,0.56-0.13,0.79-0.14L19.58,24.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M22.69,22.22c0.62-0.12,0.87,0.16,0.93,0.54c0.09,0.58,0.11,1.56-0.72,2.31 c-0.83,0.75-3.19-0.06-3.19-0.06s-0.11-0.29,0.09-0.46c0,0,1.83,0.09,2.41-0.73C22.48,23.42,22.1,22.33,22.69,22.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M26.71,35.77c0.19-0.21,0.18-0.25,0.13-0.31c-0.04-0.06-0.1-0.11-0.15-0.17l0.41-0.25 c0.08,0.15,0.15,0.29,0.18,0.4C27.24,35.47,27,35.79,26.71,35.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M27.27,35.43C27.27,35.43,27.28,35.42,27.27,35.43c0.24,0.34-0.3,0.55-0.61,0.59 c-0.31,0.05,0.05-0.25,0.05-0.25C27,35.79,27.24,35.47,27.27,35.43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.22,34.96c0.06,0.2-0.39,0.52-0.51,0.41c-1.07-0.91-2.22-2.9-2.65-3.71c-0.02-0.04-0.04-0.07-0.06-0.1 c-0.21-0.35-0.34-0.28-1.06-1.9c-0.24-0.52-0.38-1.44-0.38-1.44l0.72-0.3l1.61-0.67c0.58,0.55,0.82,2.1,0.94,2.75 c0.1,0.54,0.22,1.42,0.34,1.84C26.57,33.32,26.86,33.61,27.22,34.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M22.51,36.16c0.26-0.11,0.27-0.15,0.25-0.23c-0.02-0.07-0.04-0.14-0.07-0.22l0.48-0.06 c0.01,0.17,0.01,0.32-0.01,0.44C23.12,36.11,22.76,36.3,22.51,36.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M23.16,36.09C23.16,36.09,23.17,36.09,23.16,36.09c0.07,0.41-0.49,0.37-0.8,0.28 c-0.3-0.09,0.15-0.21,0.15-0.21C22.76,36.3,23.12,36.11,23.16,36.09z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M24.2,31.03c-0.06,0.19-0.13,0.36-0.2,0.53c-0.21-0.35-0.34-0.28-1.06-1.9c-0.24-0.52-0.38-1.44-0.38-1.44 l0.72-0.3l0.73,0.06C24.31,28.72,24.4,30.43,24.2,31.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M24.12,30.56c-0.13,0.54-0.43,1.09-0.43,1.84c0,1.53-0.14,1.87-0.37,3.24c-0.02,0.16-0.36,0.26-0.54,0.22 c-0.03-0.01-0.05-0.01-0.07-0.03c-0.02-0.01-0.03-0.02-0.03-0.03c-0.59-1.28-0.99-3.45-1.04-4.36c-0.03-0.54-0.02-0.47,0-2.4 c0.01-0.58,0.26-1.47,0.26-1.47l2.39,0.08C24.57,28.39,24.27,29.92,24.12,30.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M22.77,35.86c-0.03-0.01-0.05-0.01-0.07-0.03c-0.36-1.01-0.52-2.08-0.65-3.01 c-0.11-0.79-0.24-1.68-0.24-2.56c0-0.96,0.15-1.81,0.46-2.52c0.01-0.01,0.02-0.02,0.04-0.01c0.01,0.01,0.02,0.02,0.02,0.04 c-0.31,0.7-0.46,1.55-0.46,2.5c0,0.88,0.13,1.77,0.24,2.56C22.24,33.75,22.4,34.85,22.77,35.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M25.51,28.52c-0.15-0.51-0.34-1.01-0.62-1.27l-0.93,0.39l-2.08-0.07c0,0-0.05,0.19-0.11,0.45 C22.68,28.75,24.24,29.02,25.51,28.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M21.87,23.7c-0.36,0.45-0.6,1.36-0.1,4.14c0.11,0.61,3.85,0.76,3.77,0.14c-0.23-1.92-1.02-3.04-1.84-4.37 C23.48,23.25,22.59,22.79,21.87,23.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M18.77,26.34c0,0-0.22-0.4-0.09-0.37c0.13,0.03,0.12,0.21,0.33,0.37c0.22,0.16-0.33,0.03-0.33,0.03 L18.77,26.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M18.95,26.32c0,0-0.94-0.53-0.82-0.23c0.13,0.29,0.25,0.53,0.76,0.56L18.95,26.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M21.87,23.94c0.62-0.09,0.86,0.18,0.92,0.56c0.08,0.59,0.07,1.56-0.77,2.29 c-0.85,0.73-3.19-0.13-3.19-0.13s-0.08-0.32,0.13-0.48c0,0,1.83,0.44,2.42-0.37C21.66,25.43,21.19,24.04,21.87,23.94z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M21.54,20.98c-0.36,0.14-0.75,0.57-0.56,1.31c0.19,0.74,0.17,0.76,0,1.09c-0.46,0.86,1.2,0.36,0.95,1.2 c-0.68,2.3,2.23,1.21,2.64,0.46c0.47-0.84,0.39-2.03-0.47-2.33c-0.29-0.1-0.07-1.08-0.7-1.1C22.75,21.6,22.94,20.43,21.54,20.98 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10,26.36l0.04,0.21c0,0,0.15,0.03,0.3,0.07c0.15,0.04,0.29,0.1,0.29,0.1l0.01-0.21 c0,0-0.15-0.06-0.32-0.11C10.17,26.39,10,26.36,10,26.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.02,26.39l0.11,0.2c0,0,0.04-0.01,0.09-0.02c0.06-0.01,0.13-0.02,0.21-0.02c0.08-0.01,0.15,0,0.21,0 c0.06,0,0.1,0,0.1,0l-0.06-0.21c0,0-0.04,0-0.1,0c-0.06,0-0.15-0.01-0.23,0.01c-0.08,0.01-0.17,0.01-0.23,0.03 C9.06,26.38,9.02,26.39,9.02,26.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.18,26.87l0.17,0.16c0,0,0.03-0.03,0.07-0.07c0.04-0.05,0.1-0.08,0.17-0.13c0.12-0.1,0.27-0.15,0.27-0.15 l-0.13-0.19c0,0-0.16,0.06-0.29,0.16c-0.07,0.05-0.14,0.09-0.18,0.14C8.21,26.84,8.18,26.87,8.18,26.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.65,27.7l0.21,0.08c0,0,0.06-0.14,0.13-0.28c0.03-0.07,0.08-0.13,0.11-0.18 c0.03-0.05,0.05-0.08,0.05-0.08l-0.19-0.14c0,0-0.02,0.03-0.06,0.09c-0.03,0.05-0.09,0.12-0.12,0.2 C7.72,27.55,7.65,27.7,7.65,27.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.41,28.64l0.22,0.05c0,0,0.03-0.16,0.05-0.32c0.04-0.15,0.08-0.3,0.08-0.3l-0.22-0.07 c0,0-0.05,0.16-0.09,0.32C7.43,28.48,7.41,28.64,7.41,28.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.26,29.56l0.21,0.1c0,0,0.02-0.04,0.02-0.1c0.01-0.06,0.02-0.14,0.04-0.23C7.56,29.16,7.58,29,7.58,29 l-0.22-0.05c0,0-0.02,0.15-0.05,0.3c-0.01,0.08-0.02,0.15-0.03,0.21C7.27,29.52,7.26,29.55,7.26,29.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.95,30.41l0.18,0.16c0.01,0,0.07-0.15,0.14-0.3c0.08-0.15,0.11-0.31,0.11-0.31l-0.21-0.12 c0,0-0.03,0.15-0.1,0.29C7.01,30.27,6.96,30.42,6.95,30.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.34,31.08l0.14,0.2c-0.01-0.01,0.15-0.08,0.26-0.2c0.12-0.12,0.23-0.24,0.22-0.24l-0.17-0.17 c0.01,0.01-0.1,0.12-0.21,0.23C6.47,31.01,6.33,31.08,6.34,31.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.47,31.35l0.07,0.23c0,0,0.04,0,0.1-0.01c0.06-0.01,0.14-0.01,0.22-0.04c0.08-0.02,0.16-0.04,0.22-0.06 c0.06-0.03,0.09-0.04,0.09-0.04l-0.12-0.21c0,0-0.04,0.02-0.09,0.04c-0.06,0.01-0.13,0.03-0.2,0.05 c-0.07,0.02-0.15,0.03-0.21,0.04C5.51,31.35,5.47,31.35,5.47,31.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.56,31.31l0.01,0.23c0,0,0.16,0.02,0.33,0.04c0.08,0.01,0.16,0.01,0.23,0.02c0.06,0,0.1,0,0.1,0 l-0.05-0.23c0,0-0.04,0-0.1,0c-0.06,0-0.13-0.01-0.21-0.02C4.71,31.33,4.56,31.31,4.56,31.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.63,31.17L3.61,31.4c0,0,0.04,0,0.1,0.01c0.06,0.01,0.14,0.02,0.21,0.03c0.16,0.03,0.32,0.05,0.32,0.05 l0.02-0.23c0,0-0.15-0.02-0.3-0.05c-0.08-0.01-0.16-0.02-0.22-0.03C3.67,31.17,3.63,31.17,3.63,31.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.74,31.66l0.19,0.13c0,0,0.08-0.12,0.19-0.22c0.11-0.1,0.24-0.15,0.24-0.15l-0.08-0.21 c0,0-0.18,0.06-0.31,0.19C2.83,31.51,2.74,31.66,2.74,31.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.4,32.59l0.23,0.04c0,0,0.01-0.04,0.02-0.09c0.01-0.06,0.02-0.13,0.05-0.21c0.04-0.15,0.1-0.29,0.1-0.29 l-0.21-0.09c0,0-0.07,0.16-0.11,0.32c-0.03,0.08-0.04,0.16-0.05,0.22C2.41,32.55,2.4,32.59,2.4,32.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.34,33.56l0.23,0c0,0-0.01-0.16,0-0.31c0-0.08,0.01-0.16,0.01-0.21c0.01-0.06,0.01-0.1,0.01-0.1 l-0.23-0.02c0,0,0,0.04-0.01,0.1c0,0.06,0,0.14-0.01,0.22C2.33,33.4,2.34,33.56,2.34,33.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.45,30.94c0.2,0,0.37,0.17,0.36,0.37c0,0.2-0.17,0.37-0.37,0.36c-0.2,0-0.37-0.17-0.36-0.37 C67.08,31.1,67.25,30.93,67.45,30.94z M67.44,31.57c0.15,0,0.27-0.12,0.27-0.26c0-0.15-0.12-0.27-0.26-0.27 c-0.15,0-0.27,0.12-0.27,0.26C67.17,31.45,67.29,31.57,67.44,31.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.7,27l0.07,0.08l-0.32,0.29c-0.1,0.08-0.1,0.23-0.02,0.33l0.23,0.26c0.06,0.07,0.09,0.15,0.08,0.24 c-0.01,0.09-0.05,0.17-0.11,0.23l-0.21,0.19c-0.05,0.04-0.08,0.1-0.08,0.16c0,0.06,0.02,0.12,0.06,0.17l0.2,0.23 c0.06,0.07,0.09,0.16,0.09,0.25c-0.01,0.09-0.05,0.18-0.13,0.23l-0.15,0.12c-0.05,0.04-0.09,0.11-0.09,0.17 c0,0.07,0.02,0.13,0.07,0.18l0.3,0.28l-0.07,0.07l-0.3-0.28c-0.07-0.07-0.11-0.16-0.11-0.26c0-0.1,0.05-0.19,0.13-0.25l0.15-0.12 c0.05-0.04,0.08-0.1,0.09-0.16c0.01-0.06-0.02-0.13-0.06-0.18l-0.21-0.23c-0.06-0.07-0.09-0.15-0.09-0.24 c0.01-0.09,0.05-0.17,0.11-0.23l0.21-0.19c0.05-0.04,0.07-0.1,0.08-0.16c0-0.06-0.02-0.12-0.06-0.17l-0.23-0.26 c-0.12-0.14-0.11-0.35,0.03-0.47L67.7,27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.94,28.61c0-0.2,0.17-0.37,0.37-0.36c0.2,0,0.37,0.17,0.36,0.37c0,0.2-0.17,0.37-0.37,0.36 C4.1,28.98,3.93,28.81,3.94,28.61z M4.57,28.62c0-0.15-0.12-0.27-0.26-0.27c-0.15,0-0.27,0.12-0.27,0.26 c0,0.15,0.12,0.27,0.26,0.27C4.45,28.89,4.57,28.77,4.57,28.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,28.36l0.08-0.07l0.29,0.32c0.08,0.1,0.23,0.1,0.33,0.02l0.26-0.23c0.07-0.06,0.15-0.09,0.24-0.08 c0.09,0.01,0.17,0.05,0.23,0.11l0.19,0.21c0.04,0.05,0.1,0.08,0.16,0.08c0.06,0,0.12-0.02,0.17-0.06l0.23-0.21 c0.07-0.06,0.16-0.09,0.25-0.09c0.09,0.01,0.18,0.05,0.23,0.13l0.12,0.15c0.04,0.05,0.11,0.09,0.17,0.09 c0.07,0,0.13-0.02,0.18-0.07l0.28-0.3l0.07,0.07l-0.27,0.3c-0.07,0.07-0.16,0.11-0.26,0.11c-0.1,0-0.19-0.05-0.25-0.13 l-0.12-0.15c-0.04-0.05-0.1-0.08-0.16-0.09c-0.06-0.01-0.13,0.02-0.18,0.06l-0.23,0.21c-0.07,0.06-0.15,0.09-0.24,0.09 c-0.09-0.01-0.17-0.05-0.23-0.11l-0.19-0.21c-0.04-0.05-0.1-0.07-0.16-0.08c-0.06,0-0.12,0.02-0.17,0.06l-0.26,0.23 c-0.14,0.12-0.35,0.11-0.47-0.03L0,28.36z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot101);
export default __webpack_public_path__ + "static/media/chatbot1-01.52cc3975e4f5dc8a8bfd45d110128ab1.svg";
export { ForwardRef as ReactComponent };